import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectEntity = () => createSelector(substate, (contextState) => contextState.entity);
